module.exports = __webpack_public_path__ + "static/media/masthead-midwest-times.57fdd3aa.svg";